import request from '../utils/request'

export default {
  async list (data) {
    const ret = await request('/v1/message/list', data,'POST')
    return ret
  },
  async save (data) { 
    const ret = await request('/v1/message/save', data,'POST')
    return ret
  },
  async send (data) {
    const ret = await request('/v1/message/send', data,'POST')
    return ret
  },
  async withdraw (data) {
    const ret = await request('/v1/message/withdraw', data,'POST')
    return ret
  },
  async delete (data) { 
    const ret = await request('/v1/message/delete', data,'POST')
    return ret
  }
}
